import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import useStore from '@/store';
import { ElScrollbar } from 'element-plus';
import 'element-plus/es/components/scrollbar/style/css'


import { computed, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollPane',
  setup(__props, {
    expose: __expose
  }) {
    const store = useStore();
    const visitedViews = computed(() => store.tagsView.visitedViews);
    const scrollWidth = computed(() => {
      return store.app.sidebar.opened ? 'calc(100vw - 64px)' : 'calc(100vw - 200px)';
    });
    const scrollContainer = ref();
    function moveToTarget(currentTag) {
      const index = visitedViews.value.findIndex(tag => tag.path === currentTag.path);
      if (index > -1) {
        const el = scrollContainer.value?.$el;
        const scrollBarView = el && el.getElementsByClassName('el-scrollbar__view')[0].children;
        if (scrollBarView.length > index) {
          scrollContainer.value?.scrollTo({
            left: scrollBarView[index].offsetLeft,
            behavior: "smooth"
          });
        }
      }
    }
    __expose({
      moveToTarget
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElScrollbar), {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        vertical: false,
        always: "",
        style: _normalizeStyle({
          width: _unref(scrollWidth)
        }),
        class: "scroll-container"
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["style"]);
    };
  }
});